import { useMemo } from 'react';
import { ColumnLayout } from '@boschebike/ebds-react';
import envReader from '../../../config/envReader';
import { InternalNavigationLink } from '../../../components';

const LANG_CODES: string[] = [
  'basque', 'bg', 'ca', 'cs', 'da', 'de', 'el', 'en', 'es', 'et',
  'fi', 'fr', 'hr', 'hu', 'is', 'it', 'ja', 'lt', 'lv', 'nl',
  'no', 'pl', 'pt', 'ro', 'sl', 'slk', 'sv',
];

const LANGUAGE_LIST: { langCode: string; englishName: string; nativeName: string }[] = LANG_CODES
  .map((langCode) => {
    const englishNameRaw = new Intl.DisplayNames(['en'], { type: 'language' }).of(langCode);
    const englishName = englishNameRaw
      ? englishNameRaw.charAt(0).toUpperCase() + englishNameRaw.slice(1)
      : langCode;

    const nativeNameRaw = new Intl.DisplayNames([langCode], { type: 'language' }).of(langCode);
    const nativeName = nativeNameRaw
      ? nativeNameRaw.charAt(0).toUpperCase() + nativeNameRaw.slice(1)
      : langCode;

    return {
      langCode,
      englishName,
      nativeName,
    };
  })
  .sort((a, b) => (a.englishName || '').localeCompare(b.englishName || ''));

const INDIVIDUAL_DOC_NAME = 'Data Access Terms and Conditions for Users 2025 07 28_';

export const ServiceTinkererPage = () => {
  const documentList = useMemo(() => LANGUAGE_LIST.map((lang) => (
    <div key={lang.langCode}>
      <InternalNavigationLink
        href={`${envReader.VITE_PUBLIC_URL}/data-act/individual/${INDIVIDUAL_DOC_NAME}${lang.langCode}.pdf`}
        text={`${lang.englishName} (${lang.nativeName})`}
      />
    </div>
  )), []);

  return (
    <ColumnLayout>
      {documentList}
    </ColumnLayout>
  );
};
